import { TEnvConfig } from './env.interfact'
import { ChainId } from '@/lib/chain'

export const PROD_CONFIG: TEnvConfig = {
  amplitudeApiKey: '5ad5eaf62750651e677503e7f768a944',
  supportedChains: [
    ChainId.ETHEREUM,
    ChainId.OPTIMISM,
    ChainId.BSC,
    ChainId.BASE,
    ChainId.ARBITRUM
  ],
  defaultChainId: ChainId.OPTIMISM,
  kulapPlusApiBaseUrl: 'https://plus-api.kulap.io/api/v1',
  kulapPlusUtilityFileUrl:
    'https://kulap-plus-utility-file.s3.ap-southeast-1.amazonaws.com',
  kulapPlusTokenListFilePath: {
    [ChainId.ETHEREUM]: '/token-lists/ethereum.json',
    [ChainId.OPTIMISM]: '/token-lists/optimism.json',
    [ChainId.BSC]: '/token-lists/bsc.json',
    [ChainId.BASE]: '/token-lists/base.json',
    [ChainId.ARBITRUM]: '/token-lists/arbitrum.json'
  },
  kulapSwapFrontendUrl: 'https://swap.kulap.io',
  kulapPlusFrontendUrl: 'https://app.kulap.io',
  googleRecaptcha: '6Ld_pMUZAAAAAM5Pajn7kxKwQRbJGoqIRb3axu7Y',
  facebookAppId: '370828216898781',
  initFromFiatCurrencyAmount: '100',
  checkUserEligibilityTrade: true,
  depositSwapContractAddresses: {
    [ChainId.ETHEREUM]: '0xb76143b5dba386e75991bcb9a3a6d3d156927984',
    [ChainId.BSC]: '0xb76143b5DBa386E75991bCB9a3a6d3D156927984',
    [ChainId.OPTIMISM]: '0xb76143b5DBa386E75991bCB9a3a6d3D156927984',
    [ChainId.BASE]: '0x1Ea8c96700230b4b3D2A1C8fad4699b61EFE1B9f',
    [ChainId.ARBITRUM]: '0xb76143b5DBa386E75991bCB9a3a6d3D156927984'
  },
  thaiD: {
    apiEndpoint: 'https://imauth.bora.dopa.go.th/api/v2',
    clientId: 'WTBQbEZtcXY4bmlxcnU3c0ZWeGpIcmVQN3JVV21MSkk',
    redirectUri: 'https://plus-api.kulap.io/api/v1/kyc-provider/thaid/callback'
  }
}
